<script setup>
import SportLiveTvEventCardCover from '@/sport-live-tv/components/sport-live-tv-event-card-cover.vue';
import SportLiveTvEventCardInfo from '@/sport-live-tv/components/sport-live-tv-event-card-info.vue';

const props = defineProps({
  event: { type: Object, required: true },
  scoresVisible: { type: Boolean, default: false },
});

const emit = defineEmits(['select']);
</script>

<template>
  <button type="button" class="card card--rounded sport-live-tv-event-card" @click="emit('select', props.event)">
    <SportLiveTvEventCardCover :event="event" />
    <SportLiveTvEventCardInfo :event="event" :scores-visible="scoresVisible" />
    <span class="play-btn round-btn sport-live-tv-event-card__play" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path d="M21.44 10.72L5.96 2.98A1.38 1.38 0 004 4.213v15.474a1.373 1.373 0 002 1.233l15.44-7.74a1.38 1.38 0 000-2.467v.007z" />
      </svg>
    </span>
  </button>
</template>

<style lang="scss" scoped>
.sport-live-tv-event-card {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 2% 0;
  border: 0;
  color: inherit;
  font-family: inherit;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 10px;
    background: rgba($black, 0.5);
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    pointer-events: none;
  }

  &__play {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 1;
    margin-right: 0;
    opacity: 0;
    transform: translate(-50%, -50%);
    transition: opacity 0.3s ease-in-out;
  }

  &:hover,
  &:focus-visible {
    z-index: 11;
    transform: scale(1.1);

    &::after,
    .sport-live-tv-event-card__play {
      opacity: 1;
    }
  }
}
</style>
